import { TableColumn } from './types'

// Inline editing handlers
export function handleEditStart(
  rowIndex: number,
  columnKey: string,
  currentValue: string,
  setOpenDropdown: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setOpenDatePicker: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setEditingCell: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setEditingValue: React.Dispatch<React.SetStateAction<string>>
) {
  setOpenDropdown(null)
  setOpenDatePicker(null)
  setEditingCell({ rowIndex, columnKey })
  setEditingValue(String(currentValue || ''))
}

export function handleEditSave<T>(
  rowIndex: number,
  columnKey: string,
  editingValue: string,
  columns: TableColumn<T>[],
  data: T[],
  setEditingCell: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setEditingValue: React.Dispatch<React.SetStateAction<string>>
) {
  const column = columns.find(col => col.key === columnKey)
  if (column?.editable) {
    const row = data[rowIndex]
    if (column.editable.validate && !column.editable.validate(editingValue)) {
      return // Don't save if validation fails
    }
    column.editable.onSave(row, editingValue)
  }
  setEditingCell(null)
  setEditingValue('')
}

export function handleEditCancel(
  setEditingCell: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setEditingValue: React.Dispatch<React.SetStateAction<string>>
) {
  setEditingCell(null)
  setEditingValue('')
}

// Dropdown handlers
export function handleDropdownToggle(
  rowIndex: number,
  columnKey: string,
  openDropdown: { rowIndex: number; columnKey: string } | null,
  setOpenDropdown: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setOpenDatePicker: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setEditingCell: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>
) {
  if (openDropdown?.rowIndex === rowIndex && openDropdown?.columnKey === columnKey) {
    setOpenDropdown(null)
    setOpenDatePicker(null)
  } else {
    setOpenDropdown({ rowIndex, columnKey })
    setOpenDatePicker(null)
    setEditingCell(null)
  }
}

// DatePicker handlers
export function handleDatePickerToggle(
  rowIndex: number,
  columnKey: string,
  openDatePicker: { rowIndex: number; columnKey: string } | null,
  setOpenDatePicker: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setOpenDropdown: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>,
  setEditingCell: React.Dispatch<React.SetStateAction<{ rowIndex: number; columnKey: string } | null>>
) {
  if (openDatePicker?.rowIndex === rowIndex && openDatePicker?.columnKey === columnKey) {
    setOpenDatePicker(null)
  } else {
    setOpenDatePicker({ rowIndex, columnKey })
    setOpenDropdown(null)
    setEditingCell(null)
  }
}

